import { ErrorHandler, inject } from '@angular/core';
import { match, P } from 'ts-pattern';
import { ToastService } from '@ps/ui';
import { PSError } from '@ps/utils';

export class GlobalErrorHandler implements ErrorHandler {
  private readonly _toastService = inject(ToastService);

  public handleError(error: Error | string | PSError): void {
    if (error instanceof PSError) {
      if (error.metadata['notify']) {
        match(error.metadata['message'])
          .with(P.string, (message) => this._toastService.error(message))
          .otherwise(() => this._toastService.error(error.message));
      }
      return error.print();
    }

    console.error(GlobalErrorHandler.name, { error });
  }
}
